<script>
  import {
    streets,
    cities,
    routes,
    propertyTypes,
    divisions,
    wells,
    alertFilters
  } from '../store.js';
  import { AppController } from '../AppController';
  import { Label } from '../constants.js';
  import { FilterType } from '../constants.js';
  import { fade } from 'svelte/transition';

  const removeFilter = (filter) => AppController.removeFilter(filter);
  const addFilter = (filter) => AppController.addFilter(filter);
  const getFilterColor = (filter) => {
    switch (filter.type) {
      case FilterType.STREET:
        return 'badge-primary'
      case FilterType.CITY:
        return 'badge-danger'
      case FilterType.ROUTE:
        return 'badge-success'
      case FilterType.PROPERTY_TYPE:
        return 'badge-warning'
      default:
        return 'badge-primary'
    }
  }
  let streetFilter;
</script>

<div class="row">
  <div class="col-md-12 grid-margin stretch-card">
    <div class="card">
      <div class="card-body dashboard-tabs p-0">
        <div
          class="tab-pane fade show active"
          id="overview"
          role="tabpanel"
          aria-labelledby="overview-tab">
          <div class="d-flex flex-wrap justify-content-xl-between">
              <div class=" d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                <i class="mdi mdi-home-map-marker icon-lg mr-3 text-primary"></i>
                <div class="d-flex flex-column justify-content-around">
                  <small class="mb-1 text-muted">Street</small>
                  <div class="dropdown">
                    <a class="btn btn-secondary dropdown-toggle p-0 bg-transparent border-0 text-dark shadow-none font-weight-medium" href="#" role="button" id="dropdownMenuLinkA" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <h5 class="mb-0 d-inline-block">{Label.ALL_STREETS}</h5>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLinkA">
                      {#each $streets as street}
                        <a 
                          class="dropdown-item" 
                          on:click|preventDefault={() => addFilter({type: FilterType.STREET, value: street})}>
                            {street}
                        </a>
                      {/each}
                    </div>
                  </div>
                </div>
              </div>
            <div
              class="d-xl-flex border-md-right flex-grow-1 align-items-center
              justify-content-center p-3 item">
              <i class="mdi mdi-city icon-lg mr-3 text-danger" />
              <div class="d-flex flex-column justify-content-around">
                <small class="mb-1 text-muted">Cities</small>
                <div class="dropdown">
                  <a
                    class="btn btn-secondary dropdown-toggle p-0 bg-transparent
                    border-0 text-dark shadow-none font-weight-medium"
                    href="#"
                    role="button"
                    id="dropdownMenuLinkA"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <h5 class="mb-0 d-inline-block">{Label.ALL_CITIES}</h5>
                  </a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuLinkA">
                    {#each $cities as city}
                      <a
                        class="dropdown-item"
                        on:click|preventDefault={() => addFilter({type: FilterType.CITY, value: city})}>
                        {city}
                      </a>
                    {/each}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-xl-flex border-md-right flex-grow-1 align-items-center
              justify-content-center p-3 item">
              <i class="mdi mdi-routes icon-lg mr-3 text-success" />
              <div class="d-flex flex-column justify-content-around">
                <small class="mb-1 text-muted">Route</small>
                <div class="dropdown">
                  <a
                    class="btn btn-secondary dropdown-toggle p-0 bg-transparent
                    border-0 text-dark shadow-none font-weight-medium"
                    href="#"
                    role="button"
                    id="dropdownMenuLinkA"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <h5 class="mb-0 d-inline-block">{Label.ALL_ROUTES}</h5>
                  </a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuLinkA">
                    {#each $routes as route}
                      <a
                        class="dropdown-item"
                        on:click|preventDefault={() => addFilter({type: FilterType.ROUTE, value: route})}>
                        {route}
                      </a>
                    {/each}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-xl-flex border-md-right flex-grow-1 align-items-center
              justify-content-center p-3 item">
              <i class="mdi mdi-store icon-lg mr-3 text-warning" />
              <div class="d-flex flex-column justify-content-around">
                <small class="mb-1 text-muted">Property Type</small>
                <div class="dropdown">
                  <a
                    class="btn btn-secondary dropdown-toggle p-0 bg-transparent
                    border-0 text-dark shadow-none font-weight-medium"
                    href="#"
                    role="button"
                    id="dropdownMenuLinkA"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <h5 class="mb-0 d-inline-block">
                      {Label.ALL_TYPES}
                    </h5>
                  </a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuLinkA">
                    {#each $propertyTypes as propertyType}
                      <a
                        class="dropdown-item"
                        on:click|preventDefault={() => addFilter({type: FilterType.PROPERTY_TYPE, value: propertyType})}>
                        {propertyType}
                      </a>
                    {/each}
                  </div>
                </div>
              </div>
            </div>

            <div
              class="d-xl-flex border-md-right flex-grow-1 align-items-center
              justify-content-center p-3 item">
              <i class="mdi mdi-map-legend icon-lg mr-3 text-danger" />
              <div class="d-flex flex-column justify-content-around">
                <small class="mb-1 text-muted">Division</small>
                <div class="dropdown">
                  <a
                    class="btn btn-secondary dropdown-toggle p-0 bg-transparent
                    border-0 text-dark shadow-none font-weight-medium"
                    href="#"
                    role="button"
                    id="dropdownMenuLinkA"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <h5 class="mb-0 d-inline-block">
                      {Label.ALL_DIVISIONS}
                    </h5>
                  </a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuLinkA">
                    {#each $divisions as division}
                      <a
                        class="dropdown-item"
                        on:click|preventDefault={() => addFilter({type: FilterType.DIVISION, value: division})}>
                        {division}
                      </a>
                    {/each}
                  </div>
                </div>
              </div>
            </div>

            <div
              class="d-xl-flex border-md-right flex-grow-1 align-items-center
              justify-content-center p-3 item">
              <i class="mdi mdi-waves icon-lg mr-3 text-primary" />
              <div class="d-flex flex-column justify-content-around">
                <small class="mb-1 text-muted">Well</small>
                <div class="dropdown">
                  <a
                    class="btn btn-secondary dropdown-toggle p-0 bg-transparent
                    border-0 text-dark shadow-none font-weight-medium"
                    href="#"
                    role="button"
                    id="dropdownMenuLinkA"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <h5 class="mb-0 d-inline-block">
                      {Label.ALL_WELLS}
                    </h5>
                  </a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuLinkA">
                    {#each $wells as well}
                      <a
                        class="dropdown-item"
                        on:click|preventDefault={() => addFilter({type: FilterType.WELL, value: well})}>
                        {well}
                      </a>
                    {/each}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {#if $alertFilters.length}
          <div class='p-3 border-top' in:fade='{{duration: 1000}}' out:fade='{{duration: 1000}}'>
            {#each $alertFilters as filter }
              <span 
                class="badge badge-pill {getFilterColor(filter)} ml-1">
                {filter.value} 
                <span class='text-muted'>|</span>  <span class='remove-filter' on:click|preventDefault={() => removeFilter(filter)}>x</span>
                </span>
            {/each}
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>
<style>
  .remove-filter:hover{
    cursor: pointer;
  }

  .dropdown-menu {
    position: absolute;
    will-change: transform;
    top: 0px;
    left: 0px;
    transform: translate3d(0px,27px, 0px);
    height: 200px;
    overflow-y: scroll;
  }


</style>